import React from 'react';
import SEO from '../../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './WebDevRealEstate.css';

const WebDevRealEstate = () => {
    return (
        <div className="industry-service-page">
            <SEO 
                title="Web Dev Real Estate Services | Digi Network" 
                description="Learn more about our Web Dev Real Estate services to grow your business online with Digi Network." 
                canonical="/industries/realestate/services/webdevrealestate" 
            />

            {/* Hero Section */}
            <section className="industry-service-hero">
                <div className="industry-service-hero-bg"></div>
                <div className="container">

                        
                    <div className="industry-service-hero-content">
                        <div className="label">WEB DEVELOPMENT</div>
                        <h1>Web Development for Real Estate</h1>
                        <p className="industry-service-hero-description">Build a professional, high-converting website tailored for your real estate business. Our real estate-focused web development helps you create a powerful online presence that attracts clients and drives consultation conversions.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free Website Consultation
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>
            {/* Stats Section */}
            <section className="seo-stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-number">&lt;3s</div>
                            <div className="stat-label">Average Load Time</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">100%</div>
                            <div className="stat-label">Mobile Responsive</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">99.9%</div>
                            <div className="stat-label">Uptime Guarantee</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">2 Wks</div>
                            <div className="stat-label">Average Launch Time</div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Real Estate Web Development Services */}
            <section className="industry-service-details">
                <div className="container">
                    <h2>Real Estate Web Development Services</h2>
                    <p>Web Development strategies designed specifically for real estate businesses</p>

                    <div className="service-features-grid">
                        <div className="feature-card">
                            
                            <h3>Custom Website Design</h3>
                            <p>Create a unique, professional website that reflects your brand and appeals to clients.</p>
                            <ul>
                                <li>Custom design mockups</li>
                                <li>Brand-aligned aesthetics</li>
                                <li>User-centered design</li>
                                <li>Mobile-responsive layouts</li>
                                <li>Modern UI/UX principles</li>
                                <li>Interactive elements</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Custom Development</h3>
                            <p>Build powerful, scalable websites with custom functionality tailored to your needs.</p>
                            <ul>
                                <li>Custom CMS development</li>
                                <li>Database integration</li>
                                <li>Third-party API integration</li>
                                <li>Custom features & tools</li>
                                <li>Secure authentication</li>
                                <li>Scalable architecture</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Mobile-First Development</h3>
                            <p>Ensure your website looks perfect and functions flawlessly on all devices.</p>
                            <ul>
                                <li>Responsive design</li>
                                <li>Mobile optimization</li>
                                <li>Touch-friendly interfaces</li>
                                <li>Fast mobile loading</li>
                                <li>Progressive Web Apps</li>
                                <li>Cross-device testing</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Security & Compliance</h3>
                            <p>Protect your website and customer data with robust security measures.</p>
                            <ul>
                                <li>SSL certificate setup</li>
                                <li>Data encryption</li>
                                <li>Regular security updates</li>
                                <li>Backup systems</li>
                                <li>GDPR compliance</li>
                                <li>Privacy policy implementation</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Performance Optimization</h3>
                            <p>Build lightning-fast websites that provide excellent user experience.</p>
                            <ul>
                                <li>Page speed optimization</li>
                                <li>Image optimization</li>
                                <li>Code minification</li>
                                <li>Caching strategies</li>
                                <li>CDN integration</li>
                                <li>Core Web Vitals optimization</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Ongoing Maintenance & Support</h3>
                            <p>Keep your website running smoothly with regular updates and technical support.</p>
                            <ul>
                                <li>Software updates</li>
                                <li>Bug fixes</li>
                                <li>Technical support</li>
                                <li>Performance monitoring</li>
                                <li>Security patches</li>
                                <li>Content updates</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* Why Choose Section */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="section-header">
                        <h2>Why Choose Our Web Development Services</h2>
                        <p>Discover what makes our web development services stand out from the competition</p>
                    </div>
                    <div className="why-seo-points">
                        <div className="why-point">
                            <h4>⚡ Lightning Fast</h4>
                            <p>Optimized websites that load in under 3 seconds for better user experience and SEO.</p>
                        </div>
                        <div className="why-point">
                            <h4>📱 Mobile-First Design</h4>
                            <p>Responsive designs that look perfect on all devices and screen sizes.</p>
                        </div>
                        <div className="why-point">
                            <h4>🔒 Secure & Reliable</h4>
                            <p>Built with security best practices and backed by 99.9% uptime guarantee.</p>
                        </div>
                        <div className="why-point">
                            <h4>🎨 Conversion-Focused</h4>
                            <p>Every element is designed to guide visitors toward taking action and converting.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR PROCESS</div>
                        <h2>Our Web Development Process</h2>
                        <p>A proven methodology designed specifically for real estate businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Discovery & Planning</h3>
                            <p>Understand your goals, audience, and requirements to create the perfect solution.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Design & Development</h3>
                            <p>Create beautiful designs and develop with modern, scalable technologies.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Testing & Launch</h3>
                            <p>Rigorous testing across devices and browsers before a smooth launch.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Support & Optimization</h3>
                            <p>Ongoing maintenance, updates, and performance optimization.</p>
                        </div>
                    </div>
                </div>
            </section>



            {/* Real Estate Web Development Process */}

            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Build Your Perfect Website?</h2>
                    <p>Get a free website consultation and discover how we can help you create a high-converting online presence.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Free Website Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default WebDevRealEstate;
